import ContactUs from "./components/ContactUs";
import { useTranslation } from "react-i18next";

export function MachineryPage() {
  return (
    <main>
      <Main />
      <Content />
      <Services />
      <ContactUs />
    </main>
  );
}

function Main() {
  const { t } = useTranslation();
  
  return (
    <div
      className="py-16 relative"
      style={{
        backgroundImage: "url(/assets/img/machinery/main.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container px-8 md:px-[100px] py-[130px] relative z-10">
        <h1 className="text-left md:leading-[64px] text-[40px] md:text-5xl font-light text-white mb-8">
          {t('MachineryPage.main.title')}
        </h1>
      </div>
    </div>
  );
}

function Content() {
  const { t } = useTranslation();
  
  const machinery = [
    {
      img: "/assets/img/machinery/Slitter.jpg",
      title: t('MachineryPage.content.machinery.slitter.title'),
      description: t('MachineryPage.content.machinery.slitter.description'),
    },
    {
      img: "/assets/img/machinery/Red-Bud.png",
      title: t('MachineryPage.content.machinery.redBud.title'),
      description: t('MachineryPage.content.machinery.redBud.description'),
    },
    {
      img: "/assets/img/machinery/Multi-Blanking.jpg",
      title: t('MachineryPage.content.machinery.multiBlanking.title'),
      description: t('MachineryPage.content.machinery.multiBlanking.description'),
    },
    {
      img: "/assets/img/machinery/Nov-Hojas.jpg",
      title: t('MachineryPage.content.machinery.sheetLeveler.title'),
      description: t('MachineryPage.content.machinery.sheetLeveler.description'),
    },
    {
      img: "/assets/img/machinery/Niv-Cintas.jpg",
      title: t('MachineryPage.content.machinery.stripLeveler.title'),
      description: t('MachineryPage.content.machinery.stripLeveler.description'),
    },
    {
      img: "/assets/img/machinery/Guillotina.jpg",
      title: t('MachineryPage.content.machinery.guillotine.title'),
      description: t('MachineryPage.content.machinery.guillotine.description'),
    },
    {
      img: "/assets/img/machinery/Dobladora.jpg",
      title: t('MachineryPage.content.machinery.profileBender.title'),
      description: t('MachineryPage.content.machinery.profileBender.description'),
    },
    {
      img: "/assets/img/machinery/Troqueladora.jpg",
      title: t('MachineryPage.content.machinery.stampingPress.title'),
      description: t('MachineryPage.content.machinery.stampingPress.description'),
    },
  ];
  
  return (
    <div className="md:pb-32 w-full bg-[#F2F6FB] relative">
      <img
        className="absolute top-0 left-0 z-0"
        src="/assets/img/diagonal-left.png"
        alt="Diagonal"
        loading="lazy"
        decoding="async"
      />
      <div className="mx-auto px-8 md:px-28 pt-16 z-10">
        <div
          className={`space-y-16 transition-all duration-1000 delay-600`}
        >
          <div className="md:flex space-y-12 md:space-y-0 justify-between">
            <div className="w-full flex flex-col space-y-8 text-left">
              <h2 className="z-10 md:text-6xl text-4xl font-light text-left md:leading-[80px] leading-[50px]">
                {t('MachineryPage.content.title')}
              </h2>
            </div>
            <div className="w-full text-left relative">
              <div className="md:text-base text-sm font-medium mb-14 text-left">
                <p className={`text-[#013B8F]`}>
                  {t('MachineryPage.content.description')}
                </p>
              </div>
            </div>
          </div>
          <div className="lg:grid grid-cols-2 xl:gap-x-32 md:gap-x-16 gap-y-16 gap-x-4">
            {machinery.map((machine) => (
              <div className="mt-4 space-y-4 group" key={machine.title}>
                <div className="relative w-full rounded-xl overflow-hidden">
                  <img
                    src={machine.img}
                    alt={machine.title}
                    className="w-full h-[200px] sm:h-[250px] md:h-[300px] lg:h-[350px] xl:h-[400px] object-cover rounded-xl transform transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                    decoding="async"
                    fetchPriority="high"
                  />
                  <div className="absolute inset-0 rounded-xl bg-[#1E2C40B2] w-full h-full scale-105 opacity-0 transition-opacity duration-300 flex items-center justify-center group-hover:opacity-100">
                    <p className="text-white font-semibold text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl text-left px-4 sm:px-6 leading-snug whitespace-pre-line">
                      {machine.description || machine.title}
                    </p>
                  </div>
                </div>
                <p className="font-semibold text-lg sm:text-xl md:text-2xl lg:text-3xl">
                  {machine.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function Services() {
  const { t } = useTranslation();
  
  return (
    <div className="py-16">
      <p className="text-center md:text-[50px] text-2xl font-medium text-[#001973]">
        {t('MachineryPage.services.title')}
      </p>
      <div className="justify-between md:flex 2xl:px-32 px-4 md:py-16 py-8 space-y-4 md:space-y-0">
        <div className="flex items-center justify-center md:w-[400px] border border-[#001973] rounded-[40px] p-6">
          <p className="md:text-[28px] text-[20px] font-normal text-[#222222] m-auto">
            <span className="font-medium">{t('MachineryPage.services.forklift')}</span> {t('MachineryPage.services.forkliftCapacity')}
          </p>
        </div>
        <div className="flex items-center justify-center md:w-[400px] border border-[#001973] bg-[#0019734D]/20 rounded-[40px] p-6">
          <p className="md:text-[28px] text-[20px] font-normal text-[#001973]">
            {t('MachineryPage.services.packingLine')}
          </p>
        </div>
        <div className="flex items-center justify-center md:w-[400px] border border-[#001973] rounded-[40px] p-6">
          <p className="md:text-[28px] text-[20px] font-normal text-[#222222]">
            <span className="font-medium">{t('MachineryPage.services.cranes')}</span> {t('MachineryPage.services.cranesCapacity')} <span className="font-medium">{t('MachineryPage.services.cranesCapacityRange')}</span>
          </p>
        </div>
      </div>
    </div>
  );
}
